module.exports = __webpack_public_path__ + "static/media/logistics.b366bf3c.jpg";